<script setup lang="ts">
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import getCategories from '../lib/getCategories';

const router = useRouter();

const categories = ref<{[k: string]: {name: string}}>({});

async function init() {
  categories.value = await getCategories();
}
init();

const select = (name: string | number) => {
  router.push({ name: 'category', params: { category: name.toString().toLocaleLowerCase() } });
};
</script>

<template>
  <div class="max-w-4xl mx-auto">
    <!-- En-tête avec ligne décorative -->
    <div class="mb-8">
      <h1 class="mb-3 text-gray-900 dark:text-gray-100">
        Choisir une catégorie
      </h1>
      <p class="text-base text-gray-600 dark:text-gray-400 mb-4">
        Sélectionnez le type de document pour afficher les marqueurs disponibles
      </p>
      <!-- Ligne décorative subtile -->
      <div class="h-0.5 w-16 bg-gradient-to-r from-primary-500 to-primary-300 rounded-full"></div>
    </div>

    <!-- Liste des catégories avec cartes subtiles -->
    <div class="space-y-2.5">
      <button
        v-for="(category, key) in categories"
        :key="key"
        class="
          group
          w-full
          text-left
          px-5
          py-4
          bg-white
          dark:bg-gray-800
          border
          border-gray-200
          dark:border-gray-700
          rounded-lg
          hover:border-primary-500
          dark:hover:border-primary-500
          hover:bg-primary-50/50
          dark:hover:bg-primary-900/5
          hover:shadow-sm
          transition-all
          duration-200
          focus-ring
          cursor-pointer
        "
        @click="select(key)"
      >
        <div class="flex items-center justify-between">
          <h2 class="
              text-lg
              font-medium
              text-gray-900
              dark:text-gray-100
              group-hover:text-primary-700
              dark:group-hover:text-primary-400
              transition-colors
            ">
            {{ category.name }}
          </h2>
          <fa
            :icon="['fas', 'arrow-right']"
            class="
              text-gray-400
              dark:text-gray-600
              group-hover:text-primary-600
              dark:group-hover:text-primary-400
              group-hover:translate-x-1
              transition-all
              duration-200
            "
          />
        </div>
      </button>
    </div>
  </div>
</template>
